import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'

export function TherapyTabsList() {
  const {t} = useTranslate('common')
  return (
    <Tabs.List minWidth={'18.125rem'} width="100%">
      <Tabs.Trigger width="100%" value="protocols">
        {t('protocols')}
      </Tabs.Trigger>
      <Tabs.Trigger width="100%" value="cumulated_dose">
        {t('cumulated_dose')}
      </Tabs.Trigger>
    </Tabs.List>
  )
}
